<template>
  <q-card flat :style="$q.screen.lt.md?'':'width: 600px; max-width: 80vw;'">
    <q-card-section class="row items-center">
      <div class="text-subtitle2">
        {{goodsInfo.Goods_Name}}
        <q-badge align="top" color="red" text-color="white" class="q-ml-xs">{{ goodsInfo.Goods_Code }}</q-badge>
      </div>
      <q-space/>
      <q-btn icon="close" flat round dense v-close-popup/>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-input :dense="$q.screen.lt.md" filled type="text" label="جستجو..."
               v-model="filter"/>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-chip square color="indigo" text-color="white" label="جمع کل مانده سفارش تا کنون">
        <q-badge class="q-ml-md" color="red" text-color="white"
                 :label="lodash.sumBy(items, item=> item.TotalG_Count)"/>
      </q-chip>
      <vue-json-to-csv
          :json-data="items" v-if="items && items.length>0">
        <q-btn round color="indigo" text-color="white" icon="download">
          <q-tooltip>
            دانلود گزارش
          </q-tooltip>
        </q-btn>
      </vue-json-to-csv>
    </q-card-section>
    <q-card-section class="q-pa-xs">
      <q-table
          style="top:50px"
          :data="items"
          wrap-cells
          flat
          :rows-per-page-options="[0]"
          :filter="filter">
        <template v-slot:header>
          <q-tr>
            <td class="text-subtitle2 text-center">شماره سفارش</td>
            <td class="text-subtitle2 text-center">شماره حواله</td>
            <td class="text-subtitle2 text-center">مانده سفارش</td>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" class="my-class">
            <td class="text-center">
              <q-chip clickable square :size="$q.screen.lt.md?'sm':'md'" color="indigo-14" text-color="white"
                      :label="props.row.Sale_Num" />
            </td>
            <td class="text-center">
              <q-chip v-if="props.row.Hava_Num" clickable square :size="$q.screen.lt.md?'sm':'md'" color="indigo-14" text-color="white"
                      :label="props.row.Hava_Num" />
            </td>
            <td class="text-center">
              <q-chip clickable square :size="$q.screen.lt.md?'sm':'md'" color="red-14" text-color="white"
                      :label="props.row.TotalG_Count" />
            </td>
            <q-td>
            </q-td>
          </q-tr>
        </template>
      </q-table>

    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import VueJsonToCsv from 'vue-json-to-csv'


export default {
  name: "RemainOrdersDetail",
  components: { VueJsonToCsv},
  props: {
    goodsInfo: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      filter: '',
      items: []
    }
  },
  methods: {
    ...mapActions({
      getDetails: 'Orders/getRemainOrdersDetails'
    }),
    setRemainGoodsDetails: function () {
      this.getDetails(this.goodsInfo.Goods_ID).then((res)=>{
        this.items = res;
      })
    }
  },
  created() {
    this.setRemainGoodsDetails();
  }
}
</script>

<style scoped>

</style>